


















import {Component, Vue, Watch} from "vue-property-decorator";
import {LocationParams} from "../../params";
import {debounce} from "ant-design-vue/es/vc-table/src/utils";
import {LocationStore} from "../../store";

@Component({
    name: "LocationSearch"
})
export default class extends Vue{
    private form = {
        ...new LocationParams()
    }
    
    @Watch('form', {immediate: false, deep: true})
    onValuesChange(val: any) {
        this.handleChange(val);
    }
    
    handleChange = debounce(function (val) {
        LocationStore.updateLocationParams(val);
        LocationStore.listLocation({...val, page: 1});
    }, 500);
    handleClick() {
      this.$emit("select");
    }
}
